import { SocialNumber } from "src/app/ui/models/domains/pbm/social-number.model";
import { FederalRegistration } from "src/app/ui/models/domains/pbm/companies/federal-registration";
import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";
import { UntypedFormGroup } from "@angular/forms";

export class ContactValidator {
  private validationResult = new ValidationResult();

  public getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  public validate(companyContactForm: UntypedFormGroup) {
    if (!companyContactForm.get("name").value) {
      this.validationResult.addErrorMessage('Campo "Nome" é obrigatório');
    } else if (!companyContactForm.get("jobDescription").value) {
      this.validationResult.addErrorMessage('Campo "Cargo" é obrigatório');
    } else if (!companyContactForm.get("telephone").value && !companyContactForm.get("mobile").value) {
      this.validationResult.addErrorMessage("É obrigatório ao menos um número de contato (telefone ou celular)");
    } else if (!companyContactForm.get("email").value) {
      this.validationResult.addErrorMessage('Campo "Email" é obrigatório');
    } else if (companyContactForm.get("hasLegalRepresentativeInfo").value) {
      if (!companyContactForm.get("federalRegistration").value && !FederalRegistration.isValid(companyContactForm.get("federalRegistration").value)) {
        this.validationResult.addErrorMessage("RG inválido");
      } else if (!companyContactForm.get("socialNumber").value && !SocialNumber.isValid(companyContactForm.get("socialNumber").value)) {
        this.validationResult.addErrorMessage("CPF inválido");
      }
    }

    return this.validationResult;
  }
}
